(function () {
  var sectionSelector = '[data-section-type="grid-carousel"]';
  var mobileQuery = '(max-width: 959px)';
  var instances = new Map();

  function GridCarousel(container) {
    this.container = container;
    this.carouselElement = container.querySelector('.grid-carousel__content');
    this.mediaQuery = window.matchMedia(mobileQuery);
    this.swiper = null;
    this.isLoadingSwiper = false;
    this.isDestroyed = false;
    this.observer = null;
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
  }

  GridCarousel.prototype.load = function () {
    if (!this.carouselElement) return;

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.handleBreakpointChange);
    } else {
      this.mediaQuery.addListener(this.handleBreakpointChange);
    }

    this.handleBreakpointChange();
    this.initVisibility();
  };

  GridCarousel.prototype.handleBreakpointChange = function () {
    if (this.mediaQuery.matches) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  };

  GridCarousel.prototype.initSwiper = function () {
    var swiperChunk = window.flu && window.flu.chunks && window.flu.chunks.swiper;

    if (this.swiper || this.isLoadingSwiper || !swiperChunk) return;

    this.isLoadingSwiper = true;

    import(swiperChunk).then(function (module) {
      var mobileProductsPerView = parseInt(this.container.dataset.mobileProductsPerView, 10) || 1;

      this.isLoadingSwiper = false;

      if (this.isDestroyed || this.swiper || !this.mediaQuery.matches) return;

      this.swiper = new module.Swiper(this.carouselElement, {
        slidesPerView: mobileProductsPerView * 1.12,
        spaceBetween: 12,
        grabCursor: true,
        preloadImages: false,
        watchSlidesProgress: true,
      });
    }.bind(this));
  };

  GridCarousel.prototype.destroySwiper = function () {
    if (!this.swiper) return;

    this.swiper.destroy(true, true);
    this.swiper = null;
  };

  GridCarousel.prototype.initVisibility = function () {
    if (!this.container.classList.contains('animation')) return;

    if (!('IntersectionObserver' in window)) {
      this.container.classList.add('is-visible');
      return;
    }

    this.observer = new IntersectionObserver(function (entries) {
      var isVisible = entries.some(function (entry) {
        return entry.isIntersecting;
      });

      if (!isVisible) return;

      this.container.classList.add('is-visible');
      this.observer.disconnect();
    }.bind(this), {
      threshold: 0.15,
    });

    this.observer.observe(this.container);
  };

  GridCarousel.prototype.unload = function () {
    this.isDestroyed = true;
    this.destroySwiper();

    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener('change', this.handleBreakpointChange);
    } else {
      this.mediaQuery.removeListener(this.handleBreakpointChange);
    }

    if (this.observer) {
      this.observer.disconnect();
    }
  };

  function loadSection(container) {
    if (!container || instances.has(container)) return;

    var instance = new GridCarousel(container);
    instances.set(container, instance);
    instance.load();
  }

  function loadSections(root) {
    if (root.matches && root.matches(sectionSelector)) {
      loadSection(root);
    }

    root.querySelectorAll(sectionSelector).forEach(loadSection);
  }

  function unloadSection(sectionId) {
    instances.forEach(function (instance, container) {
      if (container.dataset.sectionId !== sectionId) return;

      instance.unload();
      instances.delete(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadSections(document);
    });
  } else {
    loadSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    loadSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unloadSection(event.detail.sectionId);
  });
})();
